/**@description All the possible statuses for a TimeSheet */
export enum TorManagerApprovalStatusEnum {
  Approved = 'A',
  InProcess = 'I',
  MoverToTimeSheet = 'M',
  Rejected = 'R',
  Withdrawn = 'W',
}
